module.exports = __webpack_public_path__ + "img/pota-3.d4a5e968.png";